import { Employee, ExtendedReferencedUser } from "@finway-group/shared/lib/models"
import { Tooltip } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { generatePath, useHistory } from "react-router-dom"
import UserImage, { UserImageBadgeType } from "~Components/UserImage"
import { ConditionalWrapper } from "~Components/conditionalWrapper"
import { FINWAY_ADMIN_EMAIL } from "~Shared/config/consts"
import { RoutePathEnum } from "~Shared/router/RoutePath.enum"

interface EmployeeLinkProps {
    employee: Employee
    avatarBadge?: UserImageBadgeType
    heightPadding?: boolean
    expenseExtendedRefUser?: ExtendedReferencedUser
    approverTypeString?: string
    // Only show replacement icon in approver related UI
    allowReplacementIcon?: boolean
}

const EmployeeLink = ({ employee, avatarBadge, expenseExtendedRefUser, heightPadding = true, approverTypeString, allowReplacementIcon = false }: EmployeeLinkProps) => {
    const { t } = useTranslation()
    const history = useHistory()
    const id = expenseExtendedRefUser?._id || employee.id
    if (!id) {
        return <></>
    }
    const { email, firstName, lastName } = expenseExtendedRefUser ?? employee
    const path = generatePath(RoutePathEnum.EMPLOYEE_DETAIL_PAGE, { id })

    const onClick = (event: any) => {
        event.preventDefault()
        history.push({ pathname: path })
    }

    // absence substitute related
    let tooltipMsg = email
    if (allowReplacementIcon && employee.substitutedBy) {
        tooltipMsg = t(`tooltips:employee_absence.substituted_by`, { substitutedBy: `${employee.substitutedBy.firstName} ${employee.substitutedBy.lastName}` })
    }
    const showReplacementIcon = allowReplacementIcon && !!employee.substitutedBy

    return (
        <ConditionalWrapper
            condition={email !== FINWAY_ADMIN_EMAIL}
            wrapper={(children) => (
                <a href={path} onClick={onClick} className="flex items-center justify-end">
                    {children}
                </a>
            )}
        >
            <Tooltip title={tooltipMsg} placement="top" className="align-middle">
                <div className="flex items-center flex-no-wrap w-full">
                    <div className={`relative ${employee.substitutedBy ? "ml-2" : ""}`}>
                        <UserImage user={employee} badge={avatarBadge} heightPadding={heightPadding} showReplacementIcon={showReplacementIcon} />
                    </div>
                    <span data-testid="finway:employeeLink:employee" className="leading-tight truncate">
                        {firstName} {lastName}
                    </span>
                    {approverTypeString && <p className="leading-none text-xs whitespace-no-wrap text-text pl-5"> {approverTypeString}</p>}
                </div>
            </Tooltip>
        </ConditionalWrapper>
    )
}

export default EmployeeLink
